// SignUpEmailSent.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const { styled, Card, Stack } = mui;

const CustomCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    maxWidth: '450px',
    padding: `${theme.spacing(4)} ${theme.spacing(1)}`, // Top-bottom: XXpx, Left-right: YYpx
    gap: theme.spacing(2),
    margin: 'auto',
    boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    [theme.breakpoints.up('sm')]: {
    width: '450px',
    },
    ...theme.applyStyles('dark', {
    boxShadow:
        'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}));

const SignUpContainer = styled(Stack)(({ theme }) => ({
    height: 'calc((1 - var(--template-frame-height, 0)) * 120dvh)',
    minHeight: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
    },
    '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
        'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
        backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
    },
}));

export default function PasswordResetEmailSent(props){

    const location = useLocation();
    const { username, email } = location.state || {}; // Access the passed data

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const confirmedTabNumber = useSelector((state) => state.home.confirmedTabNumber);
    const verseReadLogList4Book = useSelector((state) => state.home.verseReadLogList4Book);
    const bookList = useSelector((state) => state.home.bookList);
    const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);

    return (
        
        <AppTheme {...props}>

        <CssBaseline enableColorScheme />

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', height: '75vh', overflowY: 'auto' }}>

        <SignUpContainer direction="column">

            <CustomCard variant="outlined">
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

            <Grid container spacing={2} padding={2}>

                <Typography
                    component="h1"
                    variant="h4"
                    sx={{ width: '100%' }}
                >
                    重設密碼
                </Typography>

                <Typography
                    // component="h6"
                    // variant="h6"
                    sx={{ width: '100%' }}
                >
                    帳戶名稱：<b>{username}</b><br/><br/>
                    重設密碼電郵已發送至您的註冊電郵地址 <b>{email}</b>，請查看電郵並點擊「重設密碼」。<br/><br/>
                    提示：如果您未在收件箱中找到電郵，請檢查您的垃圾郵件或廣告郵件夾。
                </Typography>

            </Grid>

            </Box>

            <Box sx={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography sx={{ textAlign: 'center' }}>
                <Link
                    to='/signin'
                    variant='body2'
                    sx={{ alignSelf: 'center' }}
                >
                    登入頁面
                </Link>
                </Typography>
            </Box> 

            </CustomCard>

        </SignUpContainer>

        </div>

        </AppTheme>

    );

}